/**
 * Applies `fn` to every string found in `value` (nested objects and arrays included) and returns the new structure.
 * Non-string leaves are kept as they are.
 */
export function mapStringsDeep<T>(value: T, fn: (text: string) => string): T {
  if (typeof value === 'string') {
    return fn(value) as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => mapStringsDeep(item, fn)) as T;
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, mapStringsDeep(item, fn)]),
    ) as T;
  }
  return value;
}
